import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '../Button';
import {getUserIdpAccounts, getUserIdpAccountsReset,linkUserIdpAccount, linkUserIdpAccountReset, deleteUserIdpAccount, deleteUserIdpAccountReset} from "../../actions/security";
import { connect } from 'react-redux';
import SocialLoginButton from "../SocialLoginButton";
import {useHistory} from "react-router-dom";
import ConnectIdpErrorModal from "../Modals/ConnectIdpErrorModal";
import {setModal} from "../../actions/app";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(4)
    },
    socialConnectBox: {
        border: `solid 1px #222222`,
        borderRadius: '8px',
        padding: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
}));

const AccountSocialConnections = ({
    getUserIdpAccounts,
    getUserIdpAccountsReset,
    getUserIdpAccountsSuccess,
    userIdpAccounts,
    linkUserIdpAccount,
    linkUserIdpAccountReset,
    linkUserIdpAccountSuccess,
    linkUserIdpAccountError,
    linkUserIdpAccountErrorResponse,
    deleteUserIdpAccount,
    deleteUserIdpAccountReset,
    deleteUserIdpAccountSuccess,
    setModal
}) => {
    const classes = useStyles();
    const history = useHistory();
    const [userIdpAccountsRetrieved, setUserIdpAccountsRetrieved] = useState(false);
    const [loading, setLoading] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorTitle, setErrorTitle] = useState('');
    const [loadingOverride, setLoadingOverride] = useState(null)

    const handleDeleteIdpAccount = (idpService) => {
        setLoading(idpService);
        deleteUserIdpAccount({idpService});
    }

    useEffect(() => {
        getUserIdpAccounts();
    }, [getUserIdpAccounts]);

    useEffect(() => {
        if (getUserIdpAccountsSuccess) {
            setUserIdpAccountsRetrieved(true);
            setLoading(null);
            getUserIdpAccountsReset();
        }
    }, [getUserIdpAccountsSuccess, getUserIdpAccountsReset]);

    useEffect(() => {
        if (linkUserIdpAccountSuccess) {
            getUserIdpAccounts();
            linkUserIdpAccountReset();
        }
    }, [linkUserIdpAccountSuccess, linkUserIdpAccountReset, getUserIdpAccounts]);

    useEffect(() => {
        if (linkUserIdpAccountError) {
            if (linkUserIdpAccountErrorResponse.response.status === 409) {
                setErrorMessage('We cannot connect your Google/Facebook account at this time.');
                setErrorTitle('We are sorry');
            } else {
                setErrorMessage('There was an error when connecting your account.');
                setErrorTitle('We are sorry');
            }
            setLoadingOverride(false);
            setLoading(false);
            setModal('connect-idp-error-modal');
            linkUserIdpAccountReset();
        }
        // eslint-disable-next-line
    }, [linkUserIdpAccountError, linkUserIdpAccountReset]);

    useEffect(() => {
        if (loadingOverride !== null) {
            setLoadingOverride(null);
        }
    }, [loadingOverride])

    useEffect(() => {
        if (deleteUserIdpAccountSuccess) {
            getUserIdpAccounts();
            deleteUserIdpAccountReset();
        }
    }, [deleteUserIdpAccountSuccess, deleteUserIdpAccountReset, getUserIdpAccounts]);


    return (
        <div className={classes.root}>
            <Typography variant="h3" gutterBottom={true}>Social accounts</Typography>

            {userIdpAccountsRetrieved && (
                <>
                {[
                    {
                        name: 'google',
                        label: 'Google'
                    },{
                    //     name: 'twitter',
                    //     label: 'Twitter'
                    // },{
                        name: 'facebook',
                        label: 'Facebook'
                    },
                ].map(idpService => {
                    const isConnected = userIdpAccounts.filter(userIdpAccount => userIdpAccount.idp_service === idpService.name).length > 0;
                    return (
                        <div key={idpService.name} className={classes.socialConnectBox}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item xs>
                                    {idpService.label}{!isConnected && ' not'} connected
                                </Grid>
                                <Grid item>
                                    <div style={{width: '160px'}}>

                                        {isConnected && (
                                            <Button disabled={loading === idpService.name} loading={loading === idpService.name} color="primary" size="small" fullWidth={true} onClick={() => {handleDeleteIdpAccount(idpService.name)}}>
                                                Disconnect
                                            </Button>
                                        )}

                                        {!isConnected && (
                                            <SocialLoginButton
                                                loadingOverride={loadingOverride}
                                                history={history}
                                                idpService={idpService.name}
                                                loginCallback={linkUserIdpAccount}
                                            >
                                                Connect now
                                            </SocialLoginButton>
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    )
                })}
                </>
            )}
            <ConnectIdpErrorModal
                message={errorMessage}
                title={errorTitle}
            />
        </div>
    )
}



export default connect(
    (state) => ({
        getUserIdpAccountsSuccess: state.security.getUserIdpAccountsSuccess,
        getUserIdpAccountsError: state.security.getUserIdpAccountsError,
        userIdpAccounts: state.security.userIdpAccounts,
        linkUserIdpAccountSuccess: state.security.linkUserIdpAccountSuccess,
        linkUserIdpAccountError: state.security.linkUserIdpAccountError,
        deleteUserIdpAccountSuccess: state.security.deleteUserIdpAccountSuccess,
        deleteUserIdpAccountError: state.security.deleteUserIdpAccountError,
        linkUserIdpAccountErrorResponse: state.security.linkUserIdpAccountErrorResponse
    }),
    {
        getUserIdpAccounts,
        getUserIdpAccountsReset,
        linkUserIdpAccount,
        linkUserIdpAccountReset,
        deleteUserIdpAccount,
        deleteUserIdpAccountReset,
        setModal
    }
)(AccountSocialConnections);